export default __webpack_public_path__ + "static/media/dividends.0f2d1712.svg";